import * as React from 'react'

function SvgAt(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#ed2939" d="M0 0h900v600H0z" />
			<path fill="#fff" d="M0 200h900v200H0z" />
		</svg>
	)
}

export default SvgAt
